exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".btn-danger[data-v-79c3f5f6]{color:#fff;background-color:#fa6999;border-color:#fa6999}.btn-danger[data-v-79c3f5f6]:hover{color:#fff;background-color:#fd1361;border-color:#fd1361}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-79c3f5f6","scoped":true,"sourceMap":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./App/Components/Master/AlertPMConfig/ItemRow.vue
// module id = 992
// module chunks = 0